import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CityComingSoon from "./CityComingSoon";
import HoustonLivePage from "./HoustonLivePage";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Dynamic City Page - loads the right template based on city status
const DynamicCityPage = () => {
  const { slug } = useParams();
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCity = async () => {
      try {
        const res = await fetch(`${API_URL}/api/cities/${slug}`);
        if (res.ok) {
          const data = await res.json();
          setCity(data);
        } else if (res.status === 404) {
          setError("City not found");
        } else {
          setError("Failed to load city");
        }
      } catch (err) {
        console.error("Failed to fetch city:", err);
        setError("Connection error");
      } finally {
        setLoading(false);
      }
    };
    
    if (slug) {
      fetchCity();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0B0F] flex items-center justify-center">
        <div className="text-white/50 font-accent">Loading...</div>
      </div>
    );
  }

  if (error || !city) {
    return (
      <div className="min-h-screen bg-[#0B0B0F] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-white font-heading text-4xl mb-4">City Not Found</h1>
          <p className="text-white/50">The city you're looking for doesn't exist.</p>
          <a href="/" className="mt-6 inline-block text-[#C9F400] hover:underline">← Back to Home</a>
        </div>
      </div>
    );
  }

  // Render the appropriate template based on status
  if (city.status === "on_sale") {
    // For now, use Houston template for all ON SALE cities
    // In future, this could be a generic LiveCityPage that uses city data
    return <HoustonLivePage cityData={city} />;
  }

  // Coming Soon template
  return (
    <CityComingSoon 
      citySlug={city.slug} 
      cityName={city.cityName}
      cityData={city}
    />
  );
};

export default DynamicCityPage;
